import React, { useState } from 'react';

const CloseButtonSvg = ({
	buttonColor,
	buttonHoverColor,
	backgroundColor,
	triggerCampaignAction,
}) => {
	const [closeButtonHover, setCloseButtonHover] = useState(false);

	const onHover = () => {
		setCloseButtonHover(prevState => !prevState);
	};

	const onClickClose = () => {
		triggerCampaignAction(0);
	};

	const closeButtonStyle = {
		backgroundColor,
	};

	return (
		<div className="close-button" style={closeButtonStyle}>
			<svg
				className="close-svg"
				onClick={onClickClose}
				onMouseEnter={onHover}
				onMouseLeave={onHover}
				stroke={closeButtonHover ? buttonHoverColor : buttonColor}
				viewBox="0 0 32 32"
				width="16"
				height="16"
				xmlns="http://www.w3.org/2000/svg"
			>
				<line strokeWidth="5" x1="2" x2="30" y1="2" y2="30" />
				<line strokeWidth="5" x1="2" x2="30" y1="30" y2="2" />
			</svg>
		</div>
	);
};
export default CloseButtonSvg;
